import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2>Sorry, Url Not Found!</h2>
            <h1>404</h1>
        </div>
    );
};

export default NotFound;